module.exports = __webpack_public_path__ + "img/soviet_union.94948aaa.svg";